import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "_helpers";

const name = "ratePlans";
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, reducers: {}, extraReducers });

export const ratePlansActions = { ...slice.actions, ...extraActions };
export const ratePlansReducer = slice.reducer;

function createInitialState() {
  return {
  };
}

function createExtraActions() {
  const ratePlanBaseUrl = `${process.env.REACT_APP_API_URL}/rate-plan`;

  return {
    upsertRatePlan: upsertRatePlan(),
    getRatePlans: getRatePlans(),
    searchRatePlansForContractors: searchRatePlansForContractors(),
    upsertRatePlansBatch: upsertRatePlansBatch(),
    deleteRatePlan: deleteRatePlan(),
  };

  function upsertRatePlan() {
    return createAsyncThunk(`${name}/upsertRatePlan`, async ({ payload }) => {
      return await fetchWrapper.patch(ratePlanBaseUrl, payload);
    });
  }

  function getRatePlans() {
    return createAsyncThunk(`${name}/getRatePlans`, async ({ id, payload, token }) => {
      const { addressId, intermediaryId } = payload ?? {};
      return await fetchWrapper.get(`${ratePlanBaseUrl}/${id}?addressId=${addressId ?? ''}&intermediaryId=${intermediaryId ?? ''}`, null, token);
    });
  }

  function searchRatePlansForContractors() {
    return createAsyncThunk(`${name}/searchRatePlansForContractors`, async ({ payload }) => {
      return await fetchWrapper.post(`${ratePlanBaseUrl}/contractors`, payload);
    });
  }

  function upsertRatePlansBatch() {
    return createAsyncThunk(`${name}/upsertRatePlansBatch`, async ({ payload }) => {
      return await fetchWrapper.patch(`${ratePlanBaseUrl}/contractors/upsert-batch`, payload);
    });
  }

  function deleteRatePlan() {
    return createAsyncThunk(`${name}/deleteRatePlan`, async ({ payload }) => {
      const { ratePlanId } = payload;
      return await fetchWrapper.delete(`${ratePlanBaseUrl}/${ratePlanId}`);
    });
  }
}

function createExtraReducers() {
  return {
    ...getRatePlans(),
  };

  function getRatePlans() {
    const { fulfilled } = extraActions.getRatePlans;
    return {
      [fulfilled]: (state, action) => {
        state.ratePlans = action.payload;
      },
    };
  }
}
